module.exports = __webpack_public_path__ + "static/media/success_old.50e7a74f.png";